import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { MultiSelectOption } from "../../../../models/MultiSelectOption";
import { getDaysOfTheWeek } from "../../../../utilities/DateUtils";
import Label from "../../../label/label";
import { validateRecur, validateDays } from "../../../../utilities/Validation";

const Weekly: FC = () => {
    const {translate} = useLocale();
    const {values, setFieldValue} = useFormikContext<any>();

    const onChecked = (day: MultiSelectOption) => {
        if(values.daysOfTheWeek.includes(day.value)) {
            const daysOfTheWeek: string[] = values.daysOfTheWeek; 
            setFieldValue("daysOfTheWeek", daysOfTheWeek.filter(key => key !== day.value)) 
        }
        else {
            setFieldValue("daysOfTheWeek", [...values.daysOfTheWeek, day.value])
        }
    }

    return <div className="flex flex-col space-y-2">
        <div className="flex flex-row space-x-3">
            <span>{translate.byKey(TranslationKeys.recurEvery)}</span>
            <Field
                name="occurrences"
                valueName="occurrences"
                type="text"
                validate={(value) => validateRecur(value, translate)}
                className={`p-1 text-sm w-16 h-6 bg-gray-input overflow-hidden ml-1`} />
            <span>{translate.byKey(TranslationKeys.weeksOn)}: </span>
        </div>
        <div className="flex flex-wrap">
            {getDaysOfTheWeek(translate).map((day, index) => {
                return <div
                    key={day.value}
                    className="flex items-center text-sm font-medium w-1/4">
                    <Field
                        id={`checkbox-${day.value}`}
                        type="checkbox"
                        name="daysOfTheWeek"
                        value={day.value}
                        checkbox={values.daysOfTheWeek.includes(day.value)}
                        validate={(value) => validateDays(value, translate)}
                        onChange={() => onChecked(day)} />
                    <Label htmlFor={`checkbox-${day.value}`} className="pl-1 text-sm">{day.label}</Label>
                </div>
            })}
        </div>
    </div>
}

export default Weekly;